import { render, staticRenderFns } from "./settlementDescForm.vue?vue&type=template&id=16fd33fe&scoped=true"
import script from "./settlementDescForm.vue?vue&type=script&lang=js"
export * from "./settlementDescForm.vue?vue&type=script&lang=js"
import style0 from "./settlementDescForm.vue?vue&type=style&index=0&id=16fd33fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fd33fe",
  null
  
)

export default component.exports